// 装修攻略
const StrategyDetails = () => import('@/pages/strategy/strategyDetails.vue')
const ProfessionalAnswer = () => import('@/pages/strategy/professionalAnswer.vue')
const StandardDetails = () => import('@/pages/strategy/standardDetails.vue')


export default [

  {
    path: '/strategy/strategyDetails',
    name: '详情页',
    component: StrategyDetails,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false,
      hideAds: true

    }
  },
  {
    path: '/strategy/professionalAnswer',
    name: '专业回答',
    component: ProfessionalAnswer,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false,
      hideAds: true

    }
  },
  {
    path: '/strategy/standardDetails',
    name: '标准详情',
    component: StandardDetails,
    meta: {
      headerShow: true,
      footerShow: true,
      sidebarShow: false,
      hideAds: true

    }
  },


]



// WEBPACK FOOTER //
// ./src/router/modules/strategyRouter.js